import { IonActionSheet, IonPopover, IonList, IonButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, useIonRouter, IonChip, IonToolbar, IonText, IonAvatar, IonCol, IonIcon, IonImg, IonItem, IonLabel, IonNote, IonRow, IonThumbnail, IonRippleEffect } from '@ionic/react';
import { flag, close, people, listOutline, arrowRedoOutline, eyeOutline, alertCircleOutline, banOutline, eye, eyeOffOutline, person, closeCircleOutline, personAddOutline, ellipsisHorizontalOutline, mailOutline, heart } from 'ionicons/icons';
import { ContentInfo, ContentInterface, ContentUpdateInt } from '../data/item';
import React, { useState, useRef }  from 'react';
import { Dialog, ConfirmResult } from '@capacitor/dialog';

import NServer, { UIElement } from "../components/NServer";
import { showAlert, showConfirm } from '../components/Alert';
import Vault, { FirstTime } from '../components/Vault';
import { LANGUAGE, GetStr } from "../language/Language";

import '../pages/Main.css'; 

  
const UserTitleContent : React.FC<ContentUpdateInt> = ({ content, index, onUpdate }) => {
    
    const [menu, openMenu] = useState(false);

    // follow the user
    const followUser = async (followed: string) => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            user: content.user,
            followed: followed
        }

        var server = new NServer();
        await server.sendForm("nc_follow", state);
        if (!server.success && server.message != "")
        {
            showAlert(server.message);
        }
        else
        {
            // refresh the window
             window.location.reload()
        }
    }

    const openPopover = () => {
        openMenu(true);
    };

    // report the post
    const reportUser = () => {
        openMenu(false);
        router.push("/report/" + content.user + "/user", "forward", "push");
    }

    // block the user
    const blockUser = async () => {
        openMenu(false);

        // ask for block user
        let accept : ConfirmResult = await showConfirm(GetStr(LANGUAGE.TXT_BLOCK_CHAT_TITLE), GetStr(LANGUAGE.TXT_BLOCK_CHAT_DESC));
        if (accept.value)
        {
            doBlockUser();
        }
    }

    // block the user
    const blockList = () => {
        openMenu(false);
        router.push("/blocklist", "forward", "push");
    }

    // message the user
    const messageUser = () => {
        router.push("/chatmsg/" + content.user + "/user", "forward", "push");
    }

    // block the user
    const doBlockUser = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            to: content.user,
            type : "user"
        }

		var server = new NServer();
        await server.sendForm("block", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            router.push("/main", "back", "pop");
        }
    }

    // show the profile picture
    const showProfilePic = () => {
        router.push("/profilepic/" + encodeURIComponent(content.user_avatar), "forward", "push");
    }

    const router = useIonRouter();

    return (
        <div className="user-title">
            <IonChip className="ion-float-right" slot="end" onClick={reportUser}>
                <IonIcon icon={flag} color="primary"></IonIcon>
                <IonLabel>Report</IonLabel>
            </IonChip>
            <IonAvatar className="main-avatar ion-margin-top" onClick={showProfilePic}>
                <img src={content.user_avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonCard className="flat-card ion-no-margin ion-text-center margin-n25">
                <IonCardHeader className="margin-25 ion-no-padding ion-padding-top">
                    <IonCardTitle className="name-title"><h1><b>{content.user_name}</b>&nbsp;<img className={ content.user_bm == 1 ? "bluemark" : "ion-hide" } src="/assets/img/bm.png" /></h1></IonCardTitle>

                    {
                        content.relationship == 1 ?
                    <IonText className="ion-text-center">
                        <IonIcon icon={person} />&nbsp;&nbsp;
                        { GetStr(LANGUAGE.TXT_USER_FRIEND) }
                    </IonText>
                        :
                        content.relationship == 0 ?
                    <IonText className="ion-text-center">
                        <IonIcon icon={eye} />&nbsp;&nbsp;
                        { GetStr(LANGUAGE.TXT_USER_FOLLOWER) }
                    </IonText>
                        :
                    <div/>
                    }
                    &nbsp;&nbsp;&nbsp;
                    <IonText className="ion-text-center">
                        <IonIcon icon={people} />&nbsp;&nbsp;
                        { GetStr(LANGUAGE.TXT_FOLLOWERS) + content.likes }
                    </IonText>

                    <IonToolbar className="ion-margin-top ion-margin-bottom">
                        <div className="scroll-vert">
                            {
                                content.relationship < 0 ?
                            <IonButton className="main-but profile-but" fill="clear" color="dark" onClick={ ()=> followUser("yes") }>
                                <IonIcon icon={personAddOutline} />&nbsp;&nbsp;
                                { GetStr(LANGUAGE.TXT_USER_FOLLOW) }
                            </IonButton>
                                :
                            <IonButton className="main-but profile-but" fill="clear" color="dark" onClick={ ()=> followUser("no") }>
                                <IonIcon icon={eyeOffOutline} />&nbsp;&nbsp;
                                { GetStr(LANGUAGE.TXT_USER_UNFOLLOW) }
                            </IonButton>
                            }
                            <IonButton className="main-but profile-but" fill="clear" color="dark" onClick={messageUser}>
                                <IonIcon icon={mailOutline} />&nbsp;&nbsp;
                                { GetStr(LANGUAGE.TXT_USER_MESSAGE) }
                            </IonButton>
                            <IonButton className="main-but profile-but" fill="clear" color="dark" onClick={openPopover}>
                                <IonIcon icon={ellipsisHorizontalOutline} />&nbsp;
                            </IonButton>
                        </div>
                    </IonToolbar>
                </IonCardHeader>

                { /* menu */ }
                <IonActionSheet
                    isOpen={menu}
                    onDidDismiss={() => openMenu(false)}
                    buttons={
                        [{
                            text: GetStr(LANGUAGE.TXT_REPORT_ADMIN),
                            icon: alertCircleOutline,
                            handler: reportUser
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_BLOCK_USER),
                            icon: banOutline,
                            handler: blockUser
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_BLOCK_LIST),
                            icon: listOutline,
                            handler: blockList
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_CANCEL),
                            icon: close,
                            role: 'cancel',
                            handler: () => { openMenu(false) }
                        } ]
                    }
                    >
                </IonActionSheet>
            </IonCard>
        </div>
    );
};
  
export default UserTitleContent;